import { CloseRounded } from "@material-ui/icons";

export default function ProgressBarButton({ progress = 0, is_loading, children, is_disabled = false, onClick, disabled, onAbort, ...props }) {
  return (
    <button
      style={{
        padding: "11px",
        width: "100%",
        position: "relative",
        borderRadius: "20px",
        border: "none",
        overflow: "hidden",
        background: is_disabled || is_loading ? "#eee" : "#000000",
        cursor: is_disabled || is_loading ? "not-allowed" : "pointer"
      }}
      onClick={(e) => {
        if (!is_disabled) onClick(e)
      }}
      {...props}
    >
      {/* Progress Bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: `${progress}%`,
          background: "#000",
          transition: "width 0.2s ease"
        }}
      />

      {/* Label */}
      <span style={{ position: "relative", zIndex: 1, fontWeight: 600, color: disabled || is_loading ? "#ABABAB" : "#FFFFFF" }}>
        {is_loading ? `Loading... ${progress}%` : children}
      </span>

      {onAbort && is_loading && (
        <div
          onClick={(e) => {
            e.stopPropagation(); // Prevent triggering the button's onClick
            onAbort();
          }}
        >
          <CloseRounded style={{ position: "absolute", top: "5px", right: "5px", color: "#ABABAB", cursor: is_loading ? "pointer" : "not-allowed" }} />
        </div>
      )}
    </button>
  );
}